/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Box } from '@chakra-ui/core';
import Drop from './Drop';
import fileExample from './plantilla-migraciones-clientes.xlsx';

function App() {
  const titleSyle = {
    textAlign: 'center',
    margin: '50px auto',
  };

  return (
    <div className='App'>
      <h1 style={titleSyle}>Bienvenido al filtro de Migraciones de FITCO</h1>
      <Box
        mx='auto'
        textAlign='left'
        maxWidth='500px'
        width='80%'
        margin='0 auto'
        lineHeight='24px'
      >
        <h3 css={{ textAlign: 'center' }}>Instrucciones:</h3>
        <ol>
          <li css={{ margin: '10px auto' }}>
            Descarga la plantilla para realizar la migración{' '}
            <a download='plantilla-migraciones-clientes.xlsx' href={fileExample}>
              AQUI
            </a>
          </li>
          <li css={{ margin: '10px auto' }}>
            Pega la información de tus clientes en la plantilla respetando el
            formato indicado en las{' '}
            <a
              download
              target='_blank '
              href='https://intercom.help/fitcolatam/es/articles/4089027-que-debes-de-saber-de-la-migracion-sencilla'
            >
              INSTRUCCIONES
            </a>
          </li>
          <li css={{ margin: '10px auto' }}>
            Carga tu archivo con los datos de tus clientes arrastrándolo al
            recuadro o mediante el botón "escoge el archivo aquí"
          </li>
          <li css={{ margin: '10px auto' }}>
            Da click en el botón procesar, la validación estará lista cuando
            aparezca el botón de descargar.
          </li>
          <li css={{ margin: '10px auto' }}>
            Si tu archivo no tiene errores estará listo para subirse al sistema.
          </li>
        </ol>
      </Box>
      <Drop></Drop>
    </div>
  );
}

export default App;
